import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "@/locales/en.json";
import de from "@/locales/de.json";
import fr from "@/locales/fr.json";
import it from "@/locales/it.json";
import es from "@/locales/es.json";
import {
  persistUiLocale,
  resolveInitialUiLocale,
  SUPPORTED_UI_LOCALES,
  type SupportedUiLocale,
} from "@/lib/i18n/constants";
import { deepMergeTranslations } from "@/lib/i18n/deep-merge";

/** Non-English bundles are merged on top of English so new keys never render as raw paths. */
const resources = {
  en: { translation: en },
  de: { translation: deepMergeTranslations(en, de) },
  fr: { translation: deepMergeTranslations(en, fr) },
  it: { translation: deepMergeTranslations(en, it) },
  es: { translation: deepMergeTranslations(en, es) },
} as const;

const { lng: initialLng, shouldPersist } = resolveInitialUiLocale();
if (typeof window !== "undefined" && shouldPersist) {
  persistUiLocale(initialLng);
}

i18n.use(initReactI18next).init({
  resources,
  lng: initialLng,
  fallbackLng: "en",
  supportedLngs: [...SUPPORTED_UI_LOCALES, false] as unknown as readonly string[],
  interpolation: { escapeValue: false },
  returnNull: false,
  react: { useSuspense: false },
});

if (typeof document !== "undefined") {
  const setHtmlLang = (lng: string) => {
    document.documentElement.lang = (lng.split(/[-_]/)[0] || "en").toLowerCase();
  };
  setHtmlLang(i18n.language);
  i18n.on("languageChanged", (lng) => setHtmlLang(lng));
}

export default i18n;
